import React, { useState } from "react";
import { ListAlt } from "@mui/icons-material";
import { ListItemIcon, MenuItem } from "@mui/material";

import { useCanViewBom } from "fond/hooks/useCanViewBom";
import BomModal from "fond/project/bom/BomModal";
import { Architecture, Project } from "fond/types";

import { trackPageMenuItemClick } from "../helper";

interface IProps {
  project: Project;
  architecture: Architecture | null;
  handleClose: () => void;
}

const Bom: React.FC<IProps> = ({ project, architecture, handleClose }: IProps) => {
  const [bomModal, showBomModal] = useState(false);
  const canViewBom = useCanViewBom(project);
  const handleClick = () => {
    if (canViewBom) {
      showBomModal(true);
      handleClose();
      trackPageMenuItemClick("project", "bom", project);
    }
  };

  return (
    <>
      <MenuItem data-testid="bom-button" onClick={handleClick} disabled={!canViewBom}>
        <ListItemIcon>
          <ListAlt />
        </ListItemIcon>
        Bill of Materials
      </MenuItem>
      {bomModal && <BomModal project={project} architecture={architecture} onClose={() => showBomModal(false)} />}
    </>
  );
};

export default Bom;
